export const state = {
  uuid : null,
  showWarning : false
}

export const getters = {}

export const mutations = {
  SET_UUID (state, uuid) {
    state.uuid = uuid
  },
  SET_WARNING (state, showWarning) {
    state.showWarning = showWarning
  },
}

export const actions = {}
